import {UserComponentManager} from './UserComponentManager';
import * as pc from 'playcanvas';
import {noise} from './../../noise';
import gsap from 'gsap';
import {CreatureManager} from '../CreatureManager';
import {PlantScene} from '../PlantScene';

const Component_Fly = UserComponentManager.createComponent('fly');
Component_Fly.friction = 0.99;
Component_Fly.accScalar = 1;
Component_Fly.accChangeTreshold = 0.01;
Component_Fly.landingThreshold = 0.01;
Component_Fly.landingVelocityThreshold = 0.01;
Component_Fly.stemPosPaddingZ = 0.35;
Component_Fly.landingOffsetZ = 2;
Component_Fly.landingOffsetDecayRate = 0.99;


Component_Fly.activeLandingTargets = [];

Component_Fly.getParams = function() {
  return {
    noise_lean: {origin: 0.5, counter: 0, rate: 0.5, range: 0.5},

    // STATES ---> ROAM, LAND, LANDED, EXIT
    state: 'ROAM',
    x: {current: 0, target: 0, vel: 0, masterAcc: 0.0001, acc: 0},
    y: {current: 0, target: 0, vel: 0, masterAcc: 0.0001, acc: 0},
    z: {current: 0, target: 0, vel: 0, masteracc: 0.0001, acc: 0},
    angle: {current: 0, target: 0, vel: 0, masterAcc: 0.01, acc: 0.01},
    tilt_noise: {origin: 0, counter: 0, rate: 0.2, range: 30, value: 0},
    pan_noise: {origin: 0, counter: 0, rate: 0.2, range: 30, value: 0},
    tx_noise: {origin: 0, counter: 0, rate: 0.2, range: 1, value: 0},
    ty_noise: {origin: 0, counter: 0, rate: 0.2, range: 1, value: 0},
    tz_noise: {origin: 1.5, counter: 0, rate: 0.2, range: 0.5, value: 0},
    angle_noise: {origin: 0, counter: 0, rate: 0.75, range: 240, value: 0},
    flaprate_noise: {origin: 0.5, counter: 0, rate: 0.75, range: 0.25, value: 0},
    flapCounter: 0,
    flapRateScalar: 100,

    glb: {},
    despawning: false,

    // lifespan
    lifespan: 0,
    lifespan_max: 60,
    lifespan_min: 30,

    // landing
    landingTimer: 0,
    landingTimer_min: 10, // todo Set these to generous values once testing is done
    landingTimer_max: 20,

    exiting: false,
    entityScale: 0,
    morphs: [],
  };
};
Component_Fly.attachToEntity = function(name, entity, glb, configObj) {
  const p = Component_Fly.getParams();
  p.name = name;
  p.entity = entity;
  p.glb = glb;

  p.lifespan = pc.math.random(p.lifespan_min, p.lifespan_max);
  p.landingTimer = pc.math.random(p.landingTimer_min, p.landingTimer_max);

  // random starting positions
  const startPos = this.getRandomOffscreenCoord();
  p.x.current = startPos.x;
  p.y.current = startPos.y;
  p.z.current = startPos.z;

  // seed noise
  p.tx_noise.counter = Math.random() * 1000;
  p.ty_noise.counter = Math.random() * 1000;
  p.tz_noise.counter = Math.random() * 1000;
  p.flaprate_noise.counter = Math.random() * 1000;
  p.tilt_noise.counter = Math.random() * 1000;
  p.pan_noise.counter = Math.random() * 1000;


  glb.render.meshInstances.forEach((meshInstance) => {
    p.morphs.push(meshInstance.morphInstance);
  });

  // setup bespoke creature vars
  p.flapRateScalar = configObj.flapRateScalar;
  p.flaprate_noise.range = 0.1; //configObj.flapRateRange;
  p.flaprate_noise.rate = configObj.flapRateChangeRate;
  p.angle.masterAcc = configObj.turnRate;
  p.x.masterAcc = configObj.accX;
  p.y.masterAcc = configObj.accY;
  p.z.masterAcc = configObj.accZ;

  this.active[name] = p;
  this.scaleIn(p);
  return p;
};
Component_Fly.getRandomOffscreenCoord = function() {
  const result = {x: pc.math.random(-4, 4), y: 0, z: pc.math.random(2, 5)};
  if (Math.random() > 0.5) {
    result.y = pc.math.random(-4, -6);
  } else {
    result.y = pc.math.random(4, 6);
  }
  return result;
};
////////////////////////////////////////////////////////////////
//                                                          DO
////////////////////////////////////////////////////////////////
Component_Fly.do = function(obj, dt) {
  obj.lifespan -= dt;
  if (obj.state !== 'EXIT' && obj.lifespan < 0) {
    this.exitCreature(obj);
  }

  switch (obj.state) {
    default:
    case 'ROAM':
      this.do_ROAM(obj, dt);
      obj.landingTimer -= dt;
      if (obj.landingTimer < 0) {
        this.findLandingSpot(obj);
      }
      break;
    case 'LAND':
      this.do_LAND(obj, dt);
      break;
    case 'LANDED':
      this.do_LANDED(obj, dt);
      break;
    case 'EXIT':
      //
      break;
  }

  const flapEnergy = this.tickNoise(obj.flaprate_noise, dt);
  const flapRate = flapEnergy * obj.flapRateScalar;
  obj.x.acc = flapEnergy * obj.x.masterAcc;
  obj.y.acc = flapEnergy * obj.y.masterAcc;
  obj.z.acc = flapEnergy * obj.z.masterAcc;
  obj.angle.acc = flapEnergy * obj.angle.masterAcc;
  obj.flapCounter += (dt * flapRate);
  const flap = 0.5 + Math.sin(obj.flapCounter) * 0.5;
  for (let i = 0; i < obj.morphs.length; i++) {
    obj.morphs[i].setWeight(0, flap);
  }
  obj.angle.target = this.tickNoise(obj.angle_noise, dt);

  obj.entity.setLocalEulerAngles(this.tickNoise(obj.tilt_noise, dt), this.tickNoise(obj.pan_noise, dt), obj.angle.current);

  Component_Fly.towards(obj.angle);
  Component_Fly.towards(obj.x);
  Component_Fly.towards(obj.y);
  Component_Fly.towards(obj.z);

  if (obj.state == 'LAND') {
    obj.z.current = Math.min(obj.z.current, obj.z.target);
  }
  obj.entity.setLocalPosition(obj.x.current, obj.y.current, obj.z.current);
};
Component_Fly.towards = function(axisObj, dt) {
  if (axisObj.current < axisObj.target - Component_Fly.accChangeTreshold) {
    axisObj.vel += (axisObj.acc * Component_Fly.accScalar);
  }
  if (axisObj.current > axisObj.target + Component_Fly.accChangeTreshold) {
    axisObj.vel -= (axisObj.acc * Component_Fly.accScalar);
  }
  axisObj.current += axisObj.vel;
  axisObj.vel *= Component_Fly.friction;
};

Component_Fly.do_ROAM = function(obj, dt) {
  obj.x.target = this.tickNoise(obj.tx_noise, dt);
  obj.y.target = this.tickNoise(obj.ty_noise, dt);
  obj.z.target = this.tickNoise(obj.tz_noise, dt);
};
Component_Fly.findLandingSpot = function(obj) {
  // find unoccupied pollen vert
  const freeVerts = PlantScene.getUnoccupiedPollenVerts();
  if (freeVerts.length > 0) {
    const chosenVertObj = freeVerts[Math.floor(Math.random() * freeVerts.length)];
    chosenVertObj.occupant = obj;
    this.setLandingTarget(obj, chosenVertObj);
  }
};
Component_Fly.setLandingTarget = function(obj, pollenVertObj) {
  obj.state = 'LAND';
  obj.occupying = pollenVertObj;

  // create a TARGET_OBJ and add it to this flying component
  const targetObj = {pollenVertObj: pollenVertObj, offsetZ: Component_Fly.landingOffsetZ};
  obj.landingTarget = targetObj;
};
Component_Fly.clearLandingTarget = function(obj) {
  // remove coupling between FLY and POLLEN_VERT
  if (obj.occupying != null) {
    obj.occupying.occupant = null;
  }
  obj.occupying = null;
  obj.landingTarget = null;

  if (obj.state == 'LAND' || obj.state == 'LANDED') {
    obj.state = 'ROAM';
  }
};
Component_Fly.disturbCreaturesOnStem = function(stemIndex) {
  for (const key in this.active) {
    if (Object.hasOwnProperty.call(this.active, key)) {
      const activeCreature = this.active[key];

      if (activeCreature.state == 'LANDED') {
        if (activeCreature.landingTarget != null) {
          if (activeCreature.landingTarget.pollenVertObj.stemIndex == stemIndex) {
            this.clearLandingTarget(activeCreature);
          }
        }
      }
    }
  }
};
Component_Fly.do_LAND = function(obj, dt) {
  const vertPos = PlantScene.vert(obj.landingTarget.pollenVertObj.stemIndex, obj.landingTarget.pollenVertObj.vertIndex);
  obj.x.target = vertPos.x;
  obj.y.target = vertPos.y;
  obj.z.target = vertPos.z + Component_Fly.stemPosPaddingZ + obj.landingTarget.offsetZ;

  // pull the z target closer to the landingVert over time (apply friction, basically)
  obj.landingTarget.offsetZ *= Component_Fly.landingOffsetDecayRate;

  const arrivedX = Math.abs(obj.x.target - obj.x.current) < Component_Fly.landingThreshold;
  const arrivedY = Math.abs(obj.y.target - obj.y.current) < Component_Fly.landingThreshold;
  const arrivedZ = Math.abs(obj.z.target - obj.z.current) < Component_Fly.landingThreshold;
  // const velocityWithinThreshold = (obj.x.vel + obj.y.vel) <= Component_Fly.landingVelocityThreshold;

  if (arrivedX && arrivedY && arrivedZ) {
    obj.state = 'LANDED';
  }
};

Component_Fly.do_LANDED = function(obj, dt) {
  const vertPos = PlantScene.vert(obj.landingTarget.pollenVertObj.stemIndex, obj.landingTarget.pollenVertObj.vertIndex);
  obj.x.current = vertPos.x;
  obj.y.current = vertPos.y;
  obj.z.current = vertPos.z + Component_Fly.stemPosPaddingZ;
};

Component_Fly.setNewRoamTarget = function(obj) {
  obj.roamTargetX = pc.math.random(-3, 3);
  obj.roamTargetY = pc.math.random(-3, 3);
};
Component_Fly.tickNoise = function(noiseObj, dt) {
  noiseObj.counter += dt * noiseObj.rate;
  noiseObj.value = noiseObj.origin + noise.simplex2(noiseObj.counter, 0) * (noiseObj.range);
  return noiseObj.value;
};
Component_Fly.scaleIn = function(obj) {
  gsap.to(obj, {
    entityScale: 1,
    duration: 6,
    ease: 'back.out(2)',
    onUpdate: () => {
      obj.entity.setLocalScale(obj.entityScale, obj.entityScale, obj.entityScale);
    },
  });
};
Component_Fly.scaleOut = function(obj) {
  obj.despawning = true;
  gsap.to(obj, {
    entityScale: 0,
    delay: 5,
    duration: 10,
    ease: 'strong.in',
    onUpdate: () => {
      obj.entity.setLocalScale(obj.entityScale, obj.entityScale, 1);
    },
    onComplete: () => {
      Component_Fly.despawn(obj);
    },
  });
};
Component_Fly.exitCreature = function(obj) {
  obj.state = 'EXIT';
  const exitCoord = this.getRandomOffscreenCoord();
  obj.x.target = exitCoord.x;
  obj.y.target = exitCoord.y;
  obj.z.target = exitCoord.z;
  this.scaleOut(obj);
  this.clearLandingTarget(obj);
};
Component_Fly.despawn = function(obj) {
  // console.log("DESPAWN FLYING: " + obj.name);
  delete this.active[obj.name];
  obj.entity.destroy;
  obj = null;
  CreatureManager.start_spawnTimer_flyingCreature();
};
Component_Fly.flush = function() {
  for (const key in this.active) {
    if (Object.hasOwnProperty.call(this.active, key)) {
      let obj = this.active[key];
      delete obj.morphs;
      delete obj.glb;
      delete this.active[key];
      obj = null;
    }
  }
  this.active = {};
};


export {Component_Fly};
